import React, { FC, memo } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Chips } from '@ucheba/ui/components/Chips/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { spaceDigits } from '@ucheba/utils/helpers/number'
import StarIcon from '@ucheba/ui/icons/icon__star-filled.svg'
import { useSelector } from 'react-redux'
import { plannerProgramsSelectors } from '@ucheba/store/planner/programs'
import SC from '../base/ProgramsItem.styles'
import { IProgramsItemProps } from '../types'
import { useNearestDate } from '../bll'
import { useWantToStudy } from '../../LayoutInstitution/components/WantToStudy/bll/useWantToStudy'
import WantToStudy from '../../LayoutInstitution/components/WantToStudy/desktop'

const { Block } = SC

const ProgramsItemCourse: FC<IProgramsItemProps> = (props) => {
  const { id, name, programType, priceFrom, feedbackStats, formats, trainingForm } = props

  const date = useNearestDate(trainingForm)

  const programIds = useSelector(plannerProgramsSelectors.entityProgramsIds)

  const { isInPlanOfAdmission, handleWantToStudy } = useWantToStudy({
    id,
    ids: programIds?.entityIds || [],
    type: 'program',
  })

  return (
    <Block>
      <Grid nowrap justifyContent='space-between'>
        <GridCol width='auto' shrink='initial'>
          <Text
            firstLetterUppercase
            fontSize='medium'
            lineHeight='medium'
            fontWeight='bold'
          >
            {programType.name}
          </Text>

          <Spacing spacing='usmall' />

          <Text
            firstLetterUppercase
            fontSize='h3'
            fontWeight='bold'
            lineHeight='h3'
            color='blue'
            html={false}
          >
            <a href={`/program/${id}`} color='inherit' rel='noreferrer'>
              {name.replace(/&quot;/g, '"')}
            </a>
          </Text>

          <Spacing spacing='xxsmall' />

          <Grid nowrap justifyContent='flex-start' spacing='xsmall'>
            {feedbackStats?.score && (
              <GridCol width='auto'>
                <Text
                  html={false}
                  color='orange'
                  fontWeight='semibold'
                  lineHeight='small2'
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ display: 'inline-block' }}>
                      <StarIcon width='20px' height='20px' color='#FF6A00' />
                    </span>
                    <span style={{ display: 'inline-block', paddingLeft: '4px' }}>
                      {feedbackStats.score}
                    </span>
                  </div>
                </Text>
              </GridCol>
            )}

            {priceFrom && (
              <GridCol width='auto'>
                <Text html={false} color='gray60'>
                  <span style={{ fontWeight: 'bold', color: 'black' }}>
                    {`${spaceDigits(priceFrom)} р.`}
                  </span>{' '}
                </Text>
              </GridCol>
            )}

            {date && (
              <GridCol width='auto'>
                <Text html={false} color='gray60'>
                  <span>Начало</span>
                  <span style={{ fontWeight: 'bold', color: 'black' }}>
                    {` ${date}`}
                  </span>{' '}
                </Text>
              </GridCol>
            )}

            {trainingForm && trainingForm.duration && (
              <GridCol width='auto'>
                <Text html={false} color='gray60'>
                  <span>Длительность</span>
                  <span style={{ fontWeight: 'bold', color: 'black' }}>
                    {` ${trainingForm.duration}`}
                  </span>
                </Text>
              </GridCol>
            )}

            {trainingForm && trainingForm.academicHours && (
              <GridCol width='auto'>
                <Text html={false} color='gray60'>
                  <span>Объем</span>
                  <span style={{ fontWeight: 'bold', color: 'black' }}>
                    {` ${trainingForm.academicHours} ак. ч`}
                  </span>{' '}
                </Text>
              </GridCol>
            )}
          </Grid>

          <Spacing spacing='small' />

          <WantToStudy
            buttonText='Хочу поступить'
            isShortText
            isInPlanOfAdmission={isInPlanOfAdmission}
            handleWantToStudy={handleWantToStudy}
            size='small'
            type='program'
            programId={id}
            programType={programType.value}
            isShowingHint={false}
            alternativeButtonView='outline'
          />
        </GridCol>

        <GridCol width='auto'>
          <Grid spacing='xxsmall'>
            {formats &&
              formats.map((format) => (
                <GridCol width='auto' key={format.value}>
                  <Chips color='gray5' firstLetterUppercase>
                    {format.name}
                  </Chips>
                </GridCol>
              ))}

            {/* скидки пока не делаем */}
            {/* <GridCol width='auto'> */}
            {/*  <Chips color='gold' firstLetterUppercase> */}
            {/*    Скидка */}
            {/*  </Chips> */}
            {/* </GridCol> */}
          </Grid>
        </GridCol>
      </Grid>
    </Block>
  )
}

export { ProgramsItemCourse }
export default memo(ProgramsItemCourse)
